function activateSeeMoreListener(products) {
  products.forEach(product => {
    const sizesLink = product.querySelector('[href="#sizes"]')
    const materialsLink = product.querySelector('[href="#materials"]')
    
    if (sizesLink && materialsLink) {
      product.querySelector('[href="#sizes"]').addEventListener('click', smoothScroll);
      product.querySelector('[href="#materials"]').addEventListener('click', smoothScroll);
    }
  })
}

function smoothScroll(event) {
  event.preventDefault();
  const selector = event.target.getAttribute('href');
  const goToElement = document.querySelector(selector);
  const distance = window.pageYOffset + goToElement.getBoundingClientRect().top;
  $('html, body').delay(100).animate({
    scrollTop: distance
  }, 600);
}

export function checkForProductDetail() {
  const products = document.querySelectorAll('.product-detail-utility');
  if (products.length) {
    activateSeeMoreListener(products);
  }
}
